import { z } from 'zod';

import { OptionalEmailString } from '../validations/email';
import { PositiveMonetaryValue } from '../validations/fields';

export const OriginationData = z.object({
  fundedAtClosing: PositiveMonetaryValue.optional(),
  fundedAtClosingPrincipal: PositiveMonetaryValue.optional().describe(
    'The principal balance at original closing. Used for credit reporting on loans modified before boarding, where loanPrincipal is the modified (boarded) balance.',
  ),
  loanOfficerName: z.string().optional(),
  loanOfficerEmail: OptionalEmailString,
  loanProcessorName: z.string().optional(),
  loanProcessorEmail: OptionalEmailString,
});
export type OriginationData = z.infer<typeof OriginationData>;
